import {call, put, takeLatest, fork, all, delay, takeEvery} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as HomestayRateService from '../services/homestayRateService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import { setListHomestayRates as setListHomestayRatesAction, setListHomestayRatesByHomestays, setHomestayRate as setHomestayRateAction, setSyncHomestayRates, setSyncHomestayRateLanguage } from '../actions/homestayRateAction';
import {SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { get, omit } from 'lodash';

function* setListHomestayRateSaga() {
    yield takeLatest(Types.HOMESTAY_RATE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const pageSize = action.filters.pageSize ? action.filters.pageSize : undefined;
        const pageIndex = action.filters.pageIndex ? (action.filters.pageIndex - 1)  : undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            pageIndex, pageSize,
        }
        const result = yield call(HomestayRateService.getHomestayRates, params);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setListHomestayRatesAction(result));
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_LIST_FAIL)))
}

function* setHomestayRateSaga() {
    yield takeLatest(Types.HOMESTAY_RATE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayRateService.getHomestayRateDetail, action.id);
        yield put(setHomestayRateAction(result));
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_DETAIL_FAIL)))
}

// TRANSLATE
function* createHomestayRateTranslate() {
    yield takeLatest(Types.HOMESTAY_RATE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.createHomestayRateTranslate, action.homestayRate);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.homestayRate.translate.languageName);
        yield put({ type: Types.HOMESTAY_RATE_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_RATE_DETAIL_ACTION, id: action.homestayRate.id });
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* updateHomestayRateTranslate() {
    yield takeLatest(Types.HOMESTAY_RATE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.updateHomestayRateTranslate, action.homestayRate);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.homestayRate.translate.languageName);
        yield put({ type: Types.HOMESTAY_RATE_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_RATE_DETAIL_ACTION, id: action.homestayRate.id });
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* deleteHomestayRateTranslate() {
    yield takeLatest(Types.HOMESTAY_RATE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.deleteHomestayRateTranslate, action.homestayRate.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.homestayRate.translate.languageName);
        yield put({ type: Types.HOMESTAY_RATE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_RATE_DETAIL_ACTION, id: action.homestayRate.id });
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* sortHomestayRate() {
    yield takeLatest(Types.HOMESTAY_RATE_SORT_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayRateService.sortHomestayRate, action.homestayRates);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.HOMESTAY_RATE_SORT_SUCCESS })
        if(result.status === 200) {
            yield put({ type: Types.HOMESTAY_RATE_LIST_ACTION, filters: action.filters });
        }
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* syncHomestayRatesAllHotels() {
    yield takeLatest(Types.HOMESTAY_RATE_SYNC_ALL_HOTELS_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.syncHomestayRatesAllHotels);
        Func.sagaSuccessMessage(action, i18n.t('validation.syncSuccess'));
        yield put({ type: Types.HOMESTAY_RATE_SYNC_ALL_HOTELS_SUCCESS })
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* syncHomestayRates() {
    yield takeLatest(Types.HOMESTAY_RATE_SYNC_HOMESTAY_RATES_ACTION, Func.sagaWrapper(function* (action) {
        const payload = {
            homestayId: action?.homestayId, 
            rateCodes: action?.homestayRateCodes.length ? action?.homestayRateCodes : undefined
        }
        const result = yield call(HomestayRateService.syncHomestayRatesAll, payload);
        Func.sagaSuccessMessage(action, i18n.t('validation.syncSuccess'));
        yield put (setSyncHomestayRates(result));
        // yield put({ type: Types.HOMESTAY_RATE_SYNC_HOMESTAY_RATES_SUCCESS })
        if(action.isRefresh && result.result && result.result.length === 0) {
            yield put({ type: Types.HOMESTAY_RATE_LIST_ACTION, filters: action.filters })
        }
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* setListHomestayRateByHotelsSaga() {
    yield takeEvery(Types.HOMESTAY_RATE_LIST_BY_HOMESTAYS_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayRateService.getHomestayRatesByHomestays, action.filters);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setListHomestayRatesByHomestays(result));
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_LIST_BY_HOMESTAYS_FAIL)))
}

//cancel policy
function* updateCancelPolicy() {
    yield takeLatest(Types.HOMESTAY_RATE_CANCEL_POLICY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.updateCancelPolicy, action.cancelPolicys);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.HOMESTAY_RATE_CANCEL_POLICY_UPDATE_SUCCESS });
        const result = yield call(HomestayRateService.getHomestayRateDetail, action.id);
        yield put(setHomestayRateAction(result));
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_CANCEL_POLICY_FAIL)))
}

function* syncCancelPolicy() {
    yield takeLatest(Types.HOMESTAY_RATE_CANCEL_POLICY_SYNC_ACTION, Func.sagaWrapper(function* (action) {
        const res  = yield call(HomestayRateService.syncCancelPolicy, action.cancelPolicys);
        if(res.status === 200){
            if(res.data && res.data.data){
                Func.sagaSuccessMessage(action, i18n.t('validation.syncDifferentDataCancelPolicy'));
            }else{
                Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
            }
        }
        yield put({ type: Types.HOMESTAY_RATE_CANCEL_POLICY_SYNC_SUCCESS });
        const result = yield call(HomestayRateService.getHomestayRateDetail, action.id);
        yield put(setHomestayRateAction(result));
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_CANCEL_POLICY_FAIL)))
}

function* updateHomestayRateActive() {
    yield takeLatest(Types.HOMESTAY_RATE_UPDATE_ACTIVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.updateHomestayRateActive, action.obj.res);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.obj.name);
        yield put({ type: Types.HOMESTAY_RATE_UPDATE_ACTIVE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.HOMESTAY_RATE_LIST_ACTION, filters: action.obj.filters });
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* updateHomestayRateExtend() {
    yield takeLatest(Types.HOMESTAY_RATE_UPDATE_EXTEND_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.updateHomestayRateExtend, action.obj.res);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.obj.name);
        yield put({ type: Types.HOMESTAY_RATE_UPDATE_EXTEND_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.HOMESTAY_RATE_LIST_ACTION, filters: action.obj.filters });
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function* syncHomestayRateLanguage() {
    yield takeLatest(Types.SYNC_HOMESTAY_RATE_LANGUAGE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.syncHomestayRateLanguage, action.obj.res);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.obj.name);
        yield put({ type: Types.SYNC_HOMESTAY_RATE_LANGUAGE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.HOMESTAY_RATE_LIST_ACTION, filters: action.obj.filters });
    }, errorSyncHomestayRateLanguage(Types.SYNC_HOMESTAY_RATE_LANGUAGE_FAIL)))
}

function* updateUsageStatus() {
    yield takeLatest(Types.HOMESTAY_RATE_USAGE_STATUS_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayRateService.updateUsageStatus, action.homestayRates);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.HOMESTAY_RATE_USAGE_STATUS_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put({ type: Types.HOMESTAY_RATE_LIST_ACTION, filters: action.filters });
    }, errorHandleHomestayRate(Types.HOMESTAY_RATE_FAIL)))
}

function errorHandleHomestayRate(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'homestayRate');
}

function errorSyncHomestayRateLanguage(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType, data: get(e, 'request')})
    }, 'homestayRate', false);
}

export function* homestayRateSaga() {
    yield all([
        fork(setListHomestayRateSaga),
        fork(setHomestayRateSaga),
        fork(createHomestayRateTranslate),
        fork(updateHomestayRateTranslate),
        fork(deleteHomestayRateTranslate),
        fork(sortHomestayRate),
        fork(syncHomestayRatesAllHotels),
        fork(syncHomestayRates),
        fork(setListHomestayRateByHotelsSaga),
        fork(updateCancelPolicy),
        fork(syncCancelPolicy),
        fork(updateHomestayRateActive),
        fork(updateUsageStatus),
        fork(syncHomestayRateLanguage),
        fork(updateHomestayRateExtend)
    ])
}
